export class SchedulerTaskProgramConfiguration {
  constructor(
    public hash?: string,
    public schedulerTaskProgramHash?: string,
    public originHash?: string,
    public index?: number,
    public vibration?: number,
    public refrigeration?: string,
    public checkBreak?: boolean,
    public repetitions?: number,
    public compensation?: number,
    public verticalCompensation?: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-program-configuration.ts